import { useAuth } from './useAuth';
import { Navigate } from 'react-router-dom';

export default function PrivateRoute({ children }) {
  const { auth } = useAuth();


  /* -------------------------------------------------------
     Guard: wait until auth is fully hydrated
  ------------------------------------------------------- */
  if (!auth.isHydrated) {
    return <div style={{ padding: 24 }}>Loading…</div>;
  }

  /* -------------------------------------------------------
     Guard: must be logged in

     Checked before onboardingStatus: once hydration has settled and we know
     there is no session, onboardingStatus is null and stays null, so waiting on
     it here would hang on "Loading…" forever instead of showing the login page.
  ------------------------------------------------------- */
  if (!auth.isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  /* -------------------------------------------------------
     Guard: must have completed onboarding
  ------------------------------------------------------- */
  if (auth.onboardingStatus == null) {
    return <div style={{ padding: 24 }}>Loading…</div>;
  }

  if (auth.onboardingStatus !== 'completed') {
    return <Navigate to="/plans" replace />;
  }

  /* -------------------------------------------------------
     Access granted
  ------------------------------------------------------- */
  return children;
}
